import { QUERY_KEYS } from '@forwardflow/helpers/utils'
import { OnboardingV2Service } from '@forwardflow/services/onboardingV2.service'
import useSWR from 'swr'

export const useGetFubUsers = (
   organizationId: string,
   limit?: number,
   page?: number,
   isFUBConnected?: boolean
) => {
   return useSWR(
      [
         QUERY_KEYS.GET_FUB_USERS,
         { organizationId, limit, page, isFUBConnected },
      ],
      () => OnboardingV2Service.getFubUsers({ organizationId, limit, page })
   )
}

export const useGetFubStages = (
   orgId: string,
   limit?: number,
   page?: number,
   isFUBConnected?: boolean
) => {
   return useSWR(
      orgId
         ? [
              QUERY_KEYS.GET_FUB_STAGES,
              {
                 orgId,
                 limit: limit || undefined,
                 page: page || undefined,
                 isFUBConnected,
              },
           ]
         : null,
      () =>
         OnboardingV2Service.getFubStages({
            organizationId: orgId,
            limit: limit || undefined,
            page: page || undefined,
         }),
      {
         revalidateOnFocus: false,
         revalidateOnReconnect: true,
         dedupingInterval: 5000,
      }
   )
}

export const useGetPeopleTags = (
   orgId: string,
   page?: number,
   limit?: number,
   isFUBConnected?: boolean
) => {
   return useSWR(
      orgId && isFUBConnected
         ? [QUERY_KEYS.GET_PEOPLE_TAGS, { orgId, page, limit, isFUBConnected }]
         : null,
      () => OnboardingV2Service.getPeopleTags({ orgId, page, limit }),
      {
         revalidateOnFocus: false,
         revalidateOnReconnect: true,
         dedupingInterval: 5000,
      }
   )
}
